export const ACCESS_TOKEN = 'a_t';
export const ACCESS_TOKEN_EXPIRATION = 'a_t_e';
export const APP_INSTANCE_ID = 'a_i';
export const COMPATIBLE_PAGE = 'c_p';
export const DEVICE_DATA = 'd_d';
export const FIRST_TIME_OPEN_APP = 'f_t_o_a';
export const GAM_GIGYA_ACCOUNT_DATA = '__coresiteAccount';
export const LANGUAGE_CODE = 'l_c';
export const MARKET_CODE = 'm_c';
export const REFRESH_TOKEN = 'r_t';
export const SPICE_TOKEN = 's_t';
export const USER_NAME = 'u_n';
export const TRY_FEATURE_FIRST_SHOW = 't_f_f_s';
export const VAPE_SESSION_DISCLAIMER = 'v_s_d';
export const USAGE_STATS_DISCLAIMER = 'u_s_d';
export const DEVICE_CONNECTION_PROGRESS = 'd_c_p';
export const FINISH_ADVANCED_DIAGNOSTICS = 'f_a_d';
export const ADVANCED_DIAGNOSTICS_ATTEMPTS = 'a_d_a';
export const LEVIA_POPUPS = 'l_p';
export const FIRMWARE_RELATED_NOTES = 'f_r_n';
export const AEM_WARNINGS = 'a_w';
export const AEM_PAUSE_MODE_WARNINGS = 'a_p_m_w';
export const AEM_PAUSE_MODE_PERFORMANCE_NEEDED_WARNING = 'a_p_m_p_n_w';
